module.exports = require('./dist/Sticky');



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/index.js
// module id = 5645
// module chunks = 0